import React from "react";
import styled from "styled-components";

const StatusWraper = styled.div`
  padding: 1px;
  border-radius: 8px;
  &.active {
    background: #F12E11;
  }
`;

const StatusContent = styled.div`
  padding: 4px 5px;
  background: #ffffff;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  color: #000000;
  &.active {
    & span {
      background: #F12E11;
    }
  }
`;

const StatusItem = ({ label, value, isActive, onChange }) => {
  const handleClick = () => {
    onChange(value);
  };
  return (
    <StatusWraper className={isActive && "active"}>
      <StatusContent className={isActive && "active"} onClick={handleClick}>
        <span>{label}</span>
      </StatusContent>
    </StatusWraper>
  );
};
export default StatusItem;
